import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategoriseYesNo } from '../../../../../mechanics/rid-categorise-yes-no/rid-categorise-yes-no';

@Component({
  selector: 'app-yes-no-words-page',
  imports: [RidCategoriseYesNo],
  templateUrl: './yes-no-words-page.html',
})
export class YesNoWordsPage {
  protected readonly $router = inject(Router);
}
